<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :disable-routes="disableRoutes"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="isRoleProvider ? providerBreadcrumbs : breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { bus } from '@/main'
import { i18n } from '@/i18n'

import GenericHistorical from '@/views/historical/GenericHistorical.vue'

import { getSociedad } from '@/services/configurations/getSociedad'
import { getHistoricalByContact } from '@/services/historical/getHistoricalByContact'
import { getHistoricalByContactExcel } from '@/services/historical/getHistoricalByContactExcel'

export default {
  name: 'list-contact-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 58,
      vuexnamespace: 'historicalContact',
      headerUrl: 'masters/society/details',
      breadcrumbs: [
        { url: 'masters', name: i18n.t('masters.header') },
        { url: 'masters/society', name: i18n.t('agenda.sociedad') },
        { paths: ['Name', 'FirstSurname'] },
      ],
      providerBreadcrumbs: [
        { url: 'masters', name: i18n.t('companies.header') },
        { paths: ['Name', 'FirstSurname'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('agenda.sociedad') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleProvider: function () {
      return this.role === 9
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
  },
  methods: {
    disableRoutes: function (contact) {
      const objDisableRoutes = {
        disableSedes: this.isRoleProvider,
        disableUserProvider: ![1].includes(contact.IdCliente) || this.isRoleUserConsultaProvider || !contact.IsSeflInvoiceSociety,
        disableLinkedCompanies: this.isRoleProvider
      }
      bus.$emit('disableOptionsContact', objDisableRoutes)
    },
    getParamsAux: function (data) {
      return { idSociedad: parseInt(this.$route.params.id) }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getSociedad(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByContactExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByContact(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
